import { IconProps } from '@app/components/Atoms/Icon'
import * as React from 'react'

export const RexIcon: React.FC<IconProps> = ({ onClick, className, active, ...rest }) => {
  const primaryInactive = '#0B2B45'
  const primaryActive = '#FFFFFF'
  const accent = '#61C9DC'

  const primaryFill = active ? primaryInactive : primaryActive

  return (
    <svg
      {...rest}
      className={className}
      onClick={onClick}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(9, 8) scale(1.2)">
        {' '}
        {/* scales and centers the 22x24 shape */}
        <path
          d="M15.8194 5.49199C15.0514 3.22819 13.505 1.28417 11.4638 0C8.47931 1.68516 6.26801 4.51237 5.36597 7.79132C5.36597 7.79132 10.4483 5.15191 16.2884 7.57814C16.2008 6.84722 16.0462 6.14677 15.8245 5.49199"
          fill={primaryFill}
        />
        <path
          d="M5.18552 15.3693C4.44842 13.207 4.28862 10.8925 4.72161 8.66418C1.78867 10.6742 -0.010265 14.075 4.40716e-05 17.5976C2.14433 18.9579 4.69583 19.5111 7.21125 19.1609C6.32982 18.0188 5.64943 16.7397 5.18552 15.3693Z"
          fill={accent}
        />
        <path
          d="M21.4327 14.1106C20.6132 11.7047 18.9637 9.65913 16.7782 8.33435C16.9998 13.1665 13.9329 17.5875 9.26286 19.1255C8.87112 19.2523 8.46906 19.3589 8 19.4503C10.9226 22.8511 15.4792 24.5312 19.9482 23.851C21.9946 21.0289 22.5513 17.3895 21.4327 14.1055"
          fill={primaryFill}
        />
      </g>
    </svg>
  )
}

export default RexIcon
